function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_361",
  "data-name": "Group 361",
  transform: "translate(-1333.5 -25.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "single-02",
  transform: "translate(1342.447 27.736)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M11.513,0a5.81,5.81,0,0,1-2.96.836A5.81,5.81,0,0,1,5.593,0,5.99,5.99,0,0,0,0,5.968v1.48l.594.191a28.478,28.478,0,0,0,7.959.9,28.478,28.478,0,0,0,7.959-.9l.594-.191V5.968A5.99,5.99,0,0,0,11.513,0Z",
  transform: "translate(0 11.994)",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M5.132,11.119c2.89,0,5.132-3.219,5.132-5.987A5.132,5.132,0,0,0,0,5.132C0,7.9,2.242,11.119,5.132,11.119Z",
  transform: "translate(3.421 0)",
  fill: "current"
})), /*#__PURE__*/React.createElement("g", {
  id: "single-02-2",
  "data-name": "single-02",
  transform: "translate(1334 26)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M13.461,0A6.793,6.793,0,0,1,10,.977,6.793,6.793,0,0,1,6.539,0,7,7,0,0,0,0,6.977v1.73l.695.223A33.3,33.3,0,0,0,10,9.977,33.3,33.3,0,0,0,19.305,8.93L20,8.707V6.977A7,7,0,0,0,13.461,0Z",
  transform: "translate(0 14.023)",
  fill: "current",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M6,13c3.379,0,6-3.763,6-7A6,6,0,0,0,0,6C0,9.237,2.621,13,6,13Z",
  transform: "translate(4)",
  fill: "current",
  stroke: "#fff",
  strokeWidth: 1
})));

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.053,
    height: 25,
    viewBox: "0 0 26.053 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.21556b5d.svg";
export { ForwardRef as ReactComponent };